/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class AddressListModel extends JSONable {
  uuid: string | null = null;
  addressLine: string | null = null;
  city: string | null = null;
  state: string | null = null;
  postalCode: string | null = null;
  country: string | null = null;
  addressTypeValue: string | null = null;
  isCompanyRequired: boolean | null = null;
}
